@if (hasItems()) {
  <section class="hd-circuit-info-kernwoorden">
    @if (label()) {
      <h4 class="hd-circuit-info-kernwoorden__label">{{ label() }}</h4>
    }
    <div class="hd-circuit-info-kernwoorden__chips" role="list">
      @for (item of items(); track $index) {
        <span class="hd-circuit-info-kernwoorden__chip" role="listitem">{{ item }}</span>
      }
    </div>
  </section>
}
